import { useUserStore } from "@/store/user"

export async function useLoginTracking() {
  if (import.meta.client) {
    const config = useRuntimeConfig()
    const route = useRoute()
    const userStore = useUserStore()
    const headers = useRequestHeaders()

    try {
      await $fetch(`${config.public.API_URL}/api/events`, {
        method: "POST",
        body: {
          type: 7, // Event::Type::Login
          reference_id: userStore.userId,
          path: route.path,
          value: 1,
          text: "User Login",
          user_agent: headers["user-agent"],
          ref_domain: headers["referer"] && new URL(headers["referer"]).host,
          ref_path: headers["referer"] && new URL(headers["referer"]).path,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }
}
